import { etherUnits, formatUnits } from "viem";
import { FormatMoneyOptions, formatMoney } from "./format-money";

export const formatUnitsToMoney = (
  wei?: bigint | null,
  options: Partial<FormatMoneyOptions> & {
    unit?: "wei" | "gwei";
    decimals?: number;
    placeholder?: string;
    showSymbol?: boolean;
  } = {}
): string | undefined => {
  const {
    unit = "wei",
    placeholder,
    decimals: inputDecimals,
    ...restOptions
  } = options;

  const decimals = inputDecimals || etherUnits[unit];

  // If no value, return placeholder
  if (!wei) return placeholder;

  // Convert wei to the desired ether unit as a number
  const etherMoney = parseFloat(formatUnits(wei, decimals));

  // Return the formatted money string with or without the symbol
  return formatMoney(etherMoney, {
    ...restOptions,
  });
};
